// extracted by mini-css-extract-plugin
export default {"videoThumbnail":"UXdgDJHnmc1nIfo2LcBW"};